import {
  Route,
} from 'react-router-dom';
import React from 'react';
import TripDetails from '../../pages/trip-request';
import TripCancelSuccess from '../../pages/trip-request/cancel/trip-cancel-success';
import TripRequestMessages from '../../pages/trip-request/messages';

const useTripRequestsRoutes = () => (
  <Route path="trip-requests/:tripRequestId">
    <Route index element={<TripDetails />} />
    <Route path="cancel-success" element={<TripCancelSuccess />} />
    <Route path="/trip-requests/:tripRequestId/messages" element={<TripRequestMessages />} />
  </Route>
);

export default useTripRequestsRoutes;
